module.exports = __webpack_public_path__ + "img/9791155250167.afa22964.jpg";